import { account } from "./account";
import { beschikbaarheid } from "./beschikbaarheid";
import { common } from "./common";
import { inschrijving } from "./inschrijving";
import { overzicht } from "./overzicht";
import { planning } from "./planning";
import { ploegen } from "./ploegen";
import { session } from "./session";

/**
 * Everything this site says, in Dutch. One namespace per feature folder, plus `common` for what
 * more than one of them needs: the same seam the code is cut along.
 */
export const nl = {
  account,
  beschikbaarheid,
  common,
  inschrijving,
  overzicht,
  planning,
  ploegen,
  session,
} as const;
